export enum LocaleEnum {
  Ko = 'ko',
  En = 'en',
}
